/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserRefusedEventTimelinePayload
 */
export interface UserRefusedEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof UserRefusedEventTimelinePayload
     */
    companyCountry: string;
    /**
     * 
     * @type {string}
     * @memberof UserRefusedEventTimelinePayload
     */
    userNationalityCountry: string;
}

/**
 * Check if a given object implements the UserRefusedEventTimelinePayload interface.
 */
export function instanceOfUserRefusedEventTimelinePayload(value: object): value is UserRefusedEventTimelinePayload {
    if (!('companyCountry' in value) || value['companyCountry'] === undefined) return false;
    if (!('userNationalityCountry' in value) || value['userNationalityCountry'] === undefined) return false;
    return true;
}

export function UserRefusedEventTimelinePayloadFromJSON(json: any): UserRefusedEventTimelinePayload {
    return UserRefusedEventTimelinePayloadFromJSONTyped(json, false);
}

export function UserRefusedEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRefusedEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'companyCountry': json['companyCountry'],
        'userNationalityCountry': json['userNationalityCountry'],
    };
}

export function UserRefusedEventTimelinePayloadToJSON(value?: UserRefusedEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'companyCountry': value['companyCountry'],
        'userNationalityCountry': value['userNationalityCountry'],
    };
}

